export const getRandomBoolean = (probability_percent_for_true = 50) => {
    const probability = probability_percent_for_true / 100;

    const generate = () => {
        return Math.random() < probability;
    }

    return generate();
}